// removed by extract-text-webpack-plugin
module.exports = {"NavigationContainer":"NavigationContainer","opened":"opened","NavigationContainer__content":"NavigationContainer__content","NavigationContainer__container-left":"NavigationContainer__container-left","NavigationContainer__container-center":"NavigationContainer__container-center","NavigationContainer__container-right":"NavigationContainer__container-right","NavigationContainer__link-prev":"NavigationContainer__link-prev","enabled":"enabled","disabled":"disabled","NavigationContainer__link-next":"NavigationContainer__link-next","tablet":"tablet"};


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation-container/styles.css
// module id = 719
// module chunks = 0 1